export const NavLinkStyle = ({ isActive }) => {
  return `text-center py-3 px-6 font-pin  ${
    isActive ? "border-b-mc border-b-2 text-b-mc font-semibold" : "normal"
  }`;
};
